import { IconConfiguration } from '../types'

export const VuesticIconAliases: IconConfiguration[] = [
  {
    name: 'va-arrow-first',
    to: 'mi-first_page',
  },
  {
    name: 'va-arrow-last',
    to: 'mi-last_page',
  },
  {
    name: 'va-arrow-right',
    to: 'mi-chevron_right',
  },
  {
    name: 'va-arrow-left',
    to: 'mi-chevron_left',
  },
  {
    name: 'va-arrow-down',
    to: 'mi-expand_more',
  },
  {
    name: 'va-arrow-up',
    to: 'mi-expand_less',
  },
  {
    name: 'va-calendar',
    to: 'mi-calendar_today',
  },
  {
    name: 'va-delete',
    to: 'mi-delete_outline',
  },
  {
    name: 'va-check',
    to: 'mi-check',
  },
  {
    name: 'va-check-circle',
    to: 'mi-check_circle',
  },
  {
    name: 'va-warning',
    to: 'mi-warning',
  },
  {
    name: 'va-clear',
    to: 'mi-highlight_off',
  },
  {
    name: 'va-close',
    to: 'mi-close',
  },
  {
    name: 'va-loading',
    to: 'mi-loop',
  },
]
